export default __webpack_public_path__ + "static/media/cb_3.fdc5f0ca.png";